import { isEmpty } from '@utils/validationUtils';
import DateService from '@services/DateService';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';

export const initialValues = {
  commissionType: '',
  lineCommissionValue: '',
  lineCommissionValueCurrency: '',
  lineCommissionRate: '',
  lineCommissionApplicableOn: '',
  activeFrom: '',
  activeTo: '',
};

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      commissionType: {
        name: 'commissionType',
        title: 'Commission Type',
        placeholder: 'Commission Type',
        type: FormFieldType.select,
        value: !isEmpty(initialValues.commissionType)
          ? initialValues.commissionType
          : '',
        required: true,
        selectOptions: {},
      },
      lineCommissionValue: {
        name: 'lineCommissionValue',
        title: 'Commission',
        type: FormFieldType.currency,
        placeholder: 'Commission',
        value: initialValues.lineCommissionValue,
        conditionalHidden: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return isRate;
        },
        conditionalDisable: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return isRate;
        },
        conditionalRequired: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return !isRate;
        },
      },
      lineCommissionValueCurrency: {
        name: 'lineCommissionValueCurrency',
        title: 'Commission Currency',
        placeholder: 'Commission Currency',
        type: FormFieldType.select,
        value: !isEmpty(initialValues.lineCommissionValueCurrency)
          ? initialValues.lineCommissionValueCurrency
          : '',
        injectGlobalLov: {
          type: 'currency',
          value: 'Id',
          display: 'Title',
        },
        conditionalHidden: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return isRate;
        },
        conditionalDisable: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return isRate;
        },
        conditionalRequired: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return !isRate;
        },
      },
      lineCommissionRate: {
        name: 'lineCommissionRate',
        title: 'Commission Rate',
        type: FormFieldType.percentage,
        placeholder: 'Commission Rate',
        value: initialValues.lineCommissionRate,
        conditionalHidden: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return !isRate;
        },
        conditionalDisable: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return !isRate;
        },
        conditionalRequired: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return isRate;
        },
      },
      lineCommissionApplicableOn: {
        name: 'lineCommissionApplicableOn',
        title: 'Commission Applicable On',
        placeholder: 'Commission Applicable On',
        type: FormFieldType.select,
        value: !isEmpty(initialValues.lineCommissionApplicableOn)
          ? initialValues.lineCommissionApplicableOn
          : '',
        selectOptions: {},
        conditionalHidden: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return !isRate;
        },
        conditionalDisable: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return !isRate;
        },
        conditionalRequired: (values) => {
          const isRate = values?.commissionType?.toLowerCase() === 'rate';
          return isRate;
        },
      },
      activeFrom: {
        name: 'activeFrom',
        title: 'Active From',
        placeholder: 'Active From',
        type: FormFieldType.date,
        value: initialValues.activeFrom,
        required: true,
        customValidator: (values) => {
          const { activeTo, activeFrom } = values;
          if (
            activeTo &&
            activeFrom &&
            DateService.isDateBefore(activeTo, activeFrom)
          ) {
            return 'Effective To Date shall be equal or greater than Effective From Date';
          }
          return '';
        },
      },
      activeTo: {
        name: 'activeTo',
        title: 'Active To',
        placeholder: 'Active To',
        type: FormFieldType.date,
        value: initialValues.activeTo,
        required: true,
      },
    },
  },
];
